var render = function (_h,_vm) {var _c=_vm._c;return _c('svg',{staticClass:"ebx-icon ebx-icon--stroked",class:[].concat(_vm.data.staticClass, _vm.data.class),attrs:{"viewBox":"0 0 19 38"}},[_c('path',{attrs:{"d":"M 0 0 L 19 19 L 0 38"}})])}
var staticRenderFns = []

export { render, staticRenderFns }